import React from 'react';
export function TrustBar() {
  const partners = [{
    name: 'Moon Palace Cancun',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bTgHz94H979P6PYRZ9jfjH/WhatsApp_Image_2025-10-14_at_02.04.57.jpg'
  }, {
    name: 'AIC Hotel Group',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nnRUkziNxnhk5RQqAT5dwy/WhatsApp_Image_2025-10-14_at_02.04.56.jpg'
  }, {
    name: 'Playa Hotels & Resorts',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sUgc6eSCDxrQGXbUMNJB5Z/WhatsApp_Image_2025-10-14_at_02.04.57_%281%29.jpg'
  }, {
    name: 'Hyatt',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2Zzfpffnq6KYpT5vGp45ZW/WhatsApp_Image_2025-10-14_at_02.04.57_%282%29.jpg'
  }, {
    name: 'Lomas Travel',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bnr3MgQ8AJBDx12nwbQNDX/WhatsApp_Image_2025-10-14_at_02.04.56_%282%29.jpg'
  }, {
    name: 'Palladium Hotel Group',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kSVkKmXp2LF3DnAoiPYXZA/WhatsApp_Image_2025-10-14_at_02.04.56_%281%29.jpg'
  }];
  return <section className="py-12 bg-white" data-id="element-260">
      <div className="container mx-auto px-4 md:px-6" data-id="element-261">
        <h2 className="text-center text-lg font-medium text-[#374047]/70 mb-10" data-id="element-262">
          Trusted by Leading Resort and Production Partners
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6 items-center" data-id="element-263">
          {partners.map((partner, index) => <div key={index} className="flex justify-center items-center" data-id="element-264">
              <div className="h-24 w-full flex items-center justify-center px-4 py-3 bg-white rounded-lg shadow-sm border border-gray-100 transition-all duration-300 hover:shadow-md" data-id="element-265">
                <img src={partner.logo} alt={partner.name} className="max-h-14 max-w-full object-contain grayscale hover:grayscale-0 transition-all duration-300" data-id="element-266" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}